export const COUNTRIES = [
  {
    "code": "AF",
    "name": "Afghanistan",
    "value": "AF"
  },
  {
    "code": "AX",
    "name": "Åland Islands",
    "value": "AX"
  },
  {
    "code": "AL",
    "name": "Albania",
    "value": "AL"
  },
  {
    "code": "DZ",
    "name": "Algeria",
    "value": "DZ"
  },
  {
    "code": "AS",
    "name": "American Samoa",
    "value": "AS"
  },
  {
    "code": "AD",
    "name": "Andorra",
    "value": "AD"
  },
  {
    "code": "AO",
    "name": "Angola",
    "value": "AO"
  },
  {
    "code": "AI",
    "name": "Anguilla",
    "value": "AI"
  },
  {
    "code": "AQ",
    "name": "Antarctica",
    "value": "AQ"
  },
  {
    "code": "AG",
    "name": "Antigua and Barbuda",
    "value": "AG"
  },
  {
    "code": "AR",
    "name": "Argentina",
    "value": "AR"
  },
  {
    "code": "AM",
    "name": "Armenia",
    "value": "AM"
  },
  {
    "code": "AW",
    "name": "Aruba",
    "value": "AW"
  },
  {
    "code": "AU",
    "name": "Australia",
    "value": "AU"
  },
  {
    "code": "AT",
    "name": "Austria",
    "value": "AT"
  },
  {
    "code": "AZ",
    "name": "Azerbaijan",
    "value": "AZ"
  },
  {
    "code": "BS",
    "name": "Bahamas",
    "value": "BS"
  },
  {
    "code": "BH",
    "name": "Bahrain",
    "value": "BH"
  },
  {
    "code": "BD",
    "name": "Bangladesh",
    "value": "BD"
  },
  {
    "code": "BB",
    "name": "Barbados",
    "value": "BB"
  },
  {
    "code": "BY",
    "name": "Belarus",
    "value": "BY"
  },
  {
    "code": "BE",
    "name": "Belgium",
    "value": "BE"
  },
  {
    "code": "BZ",
    "name": "Belize",
    "value": "BZ"
  },
  {
    "code": "BJ",
    "name": "Benin",
    "value": "BJ"
  },
  {
    "code": "BM",
    "name": "Bermuda",
    "value": "BM"
  },
  {
    "code": "BT",
    "name": "Bhutan",
    "value": "BT"
  },
  {
    "code": "BO",
    "name": "Bolivia",
    "value": "BO"
  },
  {
    "code": "BA",
    "name": "Bosnia and Herzegovina",
    "value": "BA"
  },
  {
    "code": "BW",
    "name": "Botswana",
    "value": "BW"
  },
  {
    "code": "BV",
    "name": "Bouvet Island",
    "value": "BV"
  },
  {
    "code": "BR",
    "name": "Brazil",
    "value": "BR"
  },
  {
    "code": "IO",
    "name": "British Indian Ocean Territory",
    "value": "IO"
  },
  {
    "code": "BN",
    "name": "Brunei Darussalam",
    "value": "BN"
  },
  {
    "code": "BG",
    "name": "Bulgaria",
    "value": "BG"
  },
  {
    "code": "BF",
    "name": "Burkina Faso",
    "value": "BF"
  },
  {
    "code": "BI",
    "name": "Burundi",
    "value": "BI"
  },
  {
    "code": "KH",
    "name": "Cambodia",
    "value": "KH"
  },
  {
    "code": "CM",
    "name": "Cameroon",
    "value": "CM"
  },
  {
    "code": "CA",
    "name": "Canada",
    "value": "CA"
  },
  {
    "code": "CV",
    "name": "Cape Verde",
    "value": "CV"
  },
  {
    "code": "KY",
    "name": "Cayman Islands",
    "value": "KY"
  },
  {
    "code": "CF",
    "name": "Central African Republic",
    "value": "CF"
  },
  {
    "code": "TD",
    "name": "Chad",
    "value": "TD"
  },
  {
    "code": "CL",
    "name": "Chile",
    "value": "CL"
  },
  {
    "code": "CN",
    "name": "China",
    "value": "CN"
  },
  {
    "code": "CX",
    "name": "Christmas Island",
    "value": "CX"
  },
  {
    "code": "CC",
    "name": "Cocos (Keeling) Islands",
    "value": "CC"
  },
  {
    "code": "CO",
    "name": "Colombia",
    "value": "CO"
  },
  {
    "code": "KM",
    "name": "Comoros",
    "value": "KM"
  },
  {
    "code": "CG",
    "name": "Congo",
    "value": "CG"
  },
  {
    "code": "CD",
    "name": "Congo, The Democratic Republic of the",
    "value": "CD"
  },
  {
    "code": "CK",
    "name": "Cook Islands",
    "value": "CK"
  },
  {
    "code": "CR",
    "name": "Costa Rica",
    "value": "CR"
  },
  {
    "code": "CI",
    "name": "Cote D'Ivoire",
    "value": "CI"
  },
  {
    "code": "HR",
    "name": "Croatia",
    "value": "HR"
  },
  {
    "code": "CU",
    "name": "Cuba",
    "value": "CU"
  },
  {
    "code": "CY",
    "name": "Cyprus",
    "value": "CY"
  },
  {
    "code": "CZ",
    "name": "Czech Republic",
    "value": "CZ"
  },
  {
    "code": "DK",
    "name": "Denmark",
    "value": "DK"
  },
  {
    "code": "DJ",
    "name": "Djibouti",
    "value": "DJ"
  },
  {
    "code": "DM",
    "name": "Dominica",
    "value": "DM"
  },
  {
    "code": "DO",
    "name": "Dominican Republic",
    "value": "DO"
  },
  {
    "code": "EC",
    "name": "Ecuador",
    "value": "EC"
  },
  {
    "code": "EG",
    "name": "Egypt",
    "value": "EG"
  },
  {
    "code": "SV",
    "name": "El Salvador",
    "value": "SV"
  },
  {
    "code": "GQ",
    "name": "Equatorial Guinea",
    "value": "GQ"
  },
  {
    "code": "ER",
    "name": "Eritrea",
    "value": "ER"
  },
  {
    "code": "EE",
    "name": "Estonia",
    "value": "EE"
  },
  {
    "code": "ET",
    "name": "Ethiopia",
    "value": "ET"
  },
  {
    "code": "FK",
    "name": "Falkland Islands (Malvinas)",
    "value": "FK"
  },
  {
    "code": "FO",
    "name": "Faroe Islands",
    "value": "FO"
  },
  {
    "code": "FJ",
    "name": "Fiji",
    "value": "FJ"
  },
  {
    "code": "FI",
    "name": "Finland",
    "value": "FI"
  },
  {
    "code": "FR",
    "name": "France",
    "value": "FR"
  },
  {
    "code": "GF",
    "name": "French Guiana",
    "value": "GF"
  },
  {
    "code": "PF",
    "name": "French Polynesia",
    "value": "PF"
  },
  {
    "code": "TF",
    "name": "French Southern Territories",
    "value": "TF"
  },
  {
    "code": "GA",
    "name": "Gabon",
    "value": "GA"
  },
  {
    "code": "GM",
    "name": "Gambia",
    "value": "GM"
  },
  {
    "code": "GE",
    "name": "Georgia",
    "value": "GE"
  },
  {
    "code": "DE",
    "name": "Germany",
    "value": "DE"
  },
  {
    "code": "GH",
    "name": "Ghana",
    "value": "GH"
  },
  {
    "code": "GI",
    "name": "Gibraltar",
    "value": "GI"
  },
  {
    "code": "GR",
    "name": "Greece",
    "value": "GR"
  },
  {
    "code": "GL",
    "name": "Greenland",
    "value": "GL"
  },
  {
    "code": "GD",
    "name": "Grenada",
    "value": "GD"
  },
  {
    "code": "GP",
    "name": "Guadeloupe",
    "value": "GP"
  },
  {
    "code": "GU",
    "name": "Guam",
    "value": "GU"
  },
  {
    "code": "GT",
    "name": "Guatemala",
    "value": "GT"
  },
  {
    "code": "GG",
    "name": "Guernsey",
    "value": "GG"
  },
  {
    "code": "GN",
    "name": "Guinea",
    "value": "GN"
  },
  {
    "code": "GW",
    "name": "Guinea-Bissau",
    "value": "GW"
  },
  {
    "code": "GY",
    "name": "Guyana",
    "value": "GY"
  },
  {
    "code": "HT",
    "name": "Haiti",
    "value": "HT"
  },
  {
    "code": "HM",
    "name": "Heard Island and Mcdonald Islands",
    "value": "HM"
  },
  {
    "code": "VA",
    "name": "Holy See (Vatican City State)",
    "value": "VA"
  },
  {
    "code": "HN",
    "name": "Honduras",
    "value": "HN"
  },
  {
    "code": "HK",
    "name": "Hong Kong",
    "value": "HK"
  },
  {
    "code": "HU",
    "name": "Hungary",
    "value": "HU"
  },
  {
    "code": "IS",
    "name": "Iceland",
    "value": "IS"
  },
  {
    "code": "IN",
    "name": "India",
    "value": "IN"
  },
  {
    "code": "ID",
    "name": "Indonesia",
    "value": "ID"
  },
  {
    "code": "IR",
    "name": "Iran, Islamic Republic Of",
    "value": "IR"
  },
  {
    "code": "IQ",
    "name": "Iraq",
    "value": "IQ"
  },
  {
    "code": "IE",
    "name": "Ireland",
    "value": "IE"
  },
  {
    "code": "IM",
    "name": "Isle of Man",
    "value": "IM"
  },
  {
    "code": "IL",
    "name": "Israel",
    "value": "IL"
  },
  {
    "code": "IT",
    "name": "Italy",
    "value": "IT"
  },
  {
    "code": "JM",
    "name": "Jamaica",
    "value": "JM"
  },
  {
    "code": "JP",
    "name": "Japan",
    "value": "JP"
  },
  {
    "code": "JE",
    "name": "Jersey",
    "value": "JE"
  },
  {
    "code": "JO",
    "name": "Jordan",
    "value": "JO"
  },
  {
    "code": "KZ",
    "name": "Kazakhstan",
    "value": "KZ"
  },
  {
    "code": "KE",
    "name": "Kenya",
    "value": "KE"
  },
  {
    "code": "KI",
    "name": "Kiribati",
    "value": "KI"
  },
  {
    "code": "KP",
    "name": "Korea, Democratic People's Republic of",
    "value": "KP"
  },
  {
    "code": "KR",
    "name": "Korea, Republic of",
    "value": "KR"
  },
  {
    "code": "KW",
    "name": "Kuwait",
    "value": "KW"
  },
  {
    "code": "KG",
    "name": "Kyrgyzstan",
    "value": "KG"
  },
  {
    "code": "LA",
    "name": "Lao People's Democratic Republic",
    "value": "LA"
  },
  {
    "code": "LV",
    "name": "Latvia",
    "value": "LV"
  },
  {
    "code": "LB",
    "name": "Lebanon",
    "value": "LB"
  },
  {
    "code": "LS",
    "name": "Lesotho",
    "value": "LS"
  },
  {
    "code": "LR",
    "name": "Liberia",
    "value": "LR"
  },
  {
    "code": "LY",
    "name": "Libyan Arab Jamahiriya",
    "value": "LY"
  },
  {
    "code": "LI",
    "name": "Liechtenstein",
    "value": "LI"
  },
  {
    "code": "LT",
    "name": "Lithuania",
    "value": "LT"
  },
  {
    "code": "LU",
    "name": "Luxembourg",
    "value": "LU"
  },
  {
    "code": "MO",
    "name": "Macao",
    "value": "MO"
  },
  {
    "code": "MK",
    "name": "Macedonia, The Former Yugoslav Republic of",
    "value": "MK"
  },
  {
    "code": "MG",
    "name": "Madagascar",
    "value": "MG"
  },
  {
    "code": "MW",
    "name": "Malawi",
    "value": "MW"
  },
  {
    "code": "MY",
    "name": "Malaysia",
    "value": "MY"
  },
  {
    "code": "MV",
    "name": "Maldives",
    "value": "MV"
  },
  {
    "code": "ML",
    "name": "Mali",
    "value": "ML"
  },
  {
    "code": "MT",
    "name": "Malta",
    "value": "MT"
  },
  {
    "code": "MH",
    "name": "Marshall Islands",
    "value": "MH"
  },
  {
    "code": "MQ",
    "name": "Martinique",
    "value": "MQ"
  },
  {
    "code": "MR",
    "name": "Mauritania",
    "value": "MR"
  },
  {
    "code": "MU",
    "name": "Mauritius",
    "value": "MU"
  },
  {
    "code": "YT",
    "name": "Mayotte",
    "value": "YT"
  },
  {
    "code": "MX",
    "name": "Mexico",
    "value": "MX"
  },
  {
    "code": "FM",
    "name": "Micronesia, Federated States of",
    "value": "FM"
  },
  {
    "code": "MD",
    "name": "Moldova, Republic of",
    "value": "MD"
  },
  {
    "code": "MC",
    "name": "Monaco",
    "value": "MC"
  },
  {
    "code": "MN",
    "name": "Mongolia",
    "value": "MN"
  },
  {
    "code": "MS",
    "name": "Montserrat",
    "value": "MS"
  },
  {
    "code": "MA",
    "name": "Morocco",
    "value": "MA"
  },
  {
    "code": "MZ",
    "name": "Mozambique",
    "value": "MZ"
  },
  {
    "code": "MM",
    "name": "Myanmar",
    "value": "MM"
  },
  {
    "code": "NA",
    "name": "Namibia",
    "value": "NA"
  },
  {
    "code": "NR",
    "name": "Nauru",
    "value": "NR"
  },
  {
    "code": "NP",
    "name": "Nepal",
    "value": "NP"
  },
  {
    "code": "NL",
    "name": "Netherlands",
    "value": "NL"
  },
  {
    "code": "AN",
    "name": "Netherlands Antilles",
    "value": "AN"
  },
  {
    "code": "NC",
    "name": "New Caledonia",
    "value": "NC"
  },
  {
    "code": "NZ",
    "name": "New Zealand",
    "value": "NZ"
  },
  {
    "code": "NI",
    "name": "Nicaragua",
    "value": "NI"
  },
  {
    "code": "NE",
    "name": "Niger",
    "value": "NE"
  },
  {
    "code": "NG",
    "name": "Nigeria",
    "value": "NG"
  },
  {
    "code": "NU",
    "name": "Niue",
    "value": "NU"
  },
  {
    "code": "NF",
    "name": "Norfolk Island",
    "value": "NF"
  },
  {
    "code": "MP",
    "name": "Northern Mariana Islands",
    "value": "MP"
  },
  {
    "code": "NO",
    "name": "Norway",
    "value": "NO"
  },
  {
    "code": "OM",
    "name": "Oman",
    "value": "OM"
  },
  {
    "code": "PK",
    "name": "Pakistan",
    "value": "PK"
  },
  {
    "code": "PW",
    "name": "Palau",
    "value": "PW"
  },
  {
    "code": "PS",
    "name": "Palestinian Territory, Occupied",
    "value": "PS"
  },
  {
    "code": "PA",
    "name": "Panama",
    "value": "PA"
  },
  {
    "code": "PG",
    "name": "Papua New Guinea",
    "value": "PG"
  },
  {
    "code": "PY",
    "name": "Paraguay",
    "value": "PY"
  },
  {
    "code": "PE",
    "name": "Peru",
    "value": "PE"
  },
  {
    "code": "PH",
    "name": "Philippines",
    "value": "PH"
  },
  {
    "code": "PN",
    "name": "Pitcairn",
    "value": "PN"
  },
  {
    "code": "PL",
    "name": "Poland",
    "value": "PL"
  },
  {
    "code": "PT",
    "name": "Portugal",
    "value": "PT"
  },
  {
    "code": "PR",
    "name": "Puerto Rico",
    "value": "PR"
  },
  {
    "code": "QA",
    "name": "Qatar",
    "value": "QA"
  },
  {
    "code": "RE",
    "name": "Reunion",
    "value": "RE"
  },
  {
    "code": "RO",
    "name": "Romania",
    "value": "RO"
  },
  {
    "code": "RU",
    "name": "Russian Federation",
    "value": "RU"
  },
  {
    "code": "RW",
    "name": "Rwanda",
    "value": "RW"
  },
  {
    "code": "SH",
    "name": "Saint Helena",
    "value": "SH"
  },
  {
    "code": "KN",
    "name": "Saint Kitts and Nevis",
    "value": "KN"
  },
  {
    "code": "LC",
    "name": "Saint Lucia",
    "value": "LC"
  },
  {
    "code": "PM",
    "name": "Saint Pierre and Miquelon",
    "value": "PM"
  },
  {
    "code": "VC",
    "name": "Saint Vincent and the Grenadines",
    "value": "VC"
  },
  {
    "code": "WS",
    "name": "Samoa",
    "value": "WS"
  },
  {
    "code": "SM",
    "name": "San Marino",
    "value": "SM"
  },
  {
    "code": "ST",
    "name": "Sao Tome and Principe",
    "value": "ST"
  },
  {
    "code": "SA",
    "name": "Saudi Arabia",
    "value": "SA"
  },
  {
    "code": "SN",
    "name": "Senegal",
    "value": "SN"
  },
  {
    "code": "CS",
    "name": "Serbia and Montenegro",
    "value": "CS"
  },
  {
    "code": "SC",
    "name": "Seychelles",
    "value": "SC"
  },
  {
    "code": "SL",
    "name": "Sierra Leone",
    "value": "SL"
  },
  {
    "code": "SG",
    "name": "Singapore",
    "value": "SG"
  },
  {
    "code": "SK",
    "name": "Slovakia",
    "value": "SK"
  },
  {
    "code": "SI",
    "name": "Slovenia",
    "value": "SI"
  },
  {
    "code": "SB",
    "name": "Solomon Islands",
    "value": "SB"
  },
  {
    "code": "SO",
    "name": "Somalia",
    "value": "SO"
  },
  {
    "code": "ZA",
    "name": "South Africa",
    "value": "ZA"
  },
  {
    "code": "GS",
    "name": "South Georgia and the South Sandwich Islands",
    "value": "GS"
  },
  {
    "code": "ES",
    "name": "Spain",
    "value": "ES"
  },
  {
    "code": "LK",
    "name": "Sri Lanka",
    "value": "LK"
  },
  {
    "code": "SD",
    "name": "Sudan",
    "value": "SD"
  },
  {
    "code": "SR",
    "name": "Surilabel",
    "value": "SR"
  },
  {
    "code": "SJ",
    "name": "Svalbard and Jan Mayen",
    "value": "SJ"
  },
  {
    "code": "SZ",
    "name": "Swaziland",
    "value": "SZ"
  },
  {
    "code": "SE",
    "name": "Sweden",
    "value": "SE"
  },
  {
    "code": "CH",
    "name": "Switzerland",
    "value": "CH"
  },
  {
    "code": "SY",
    "name": "Syrian Arab Republic",
    "value": "SY"
  },
  {
    "code": "TW",
    "name": "Taiwan",
    "value": "TW"
  },
  {
    "code": "TJ",
    "name": "Tajikistan",
    "value": "TJ"
  },
  {
    "code": "TZ",
    "name": "Tanzania, United Republic of",
    "value": "TZ"
  },
  {
    "code": "TH",
    "name": "Thailand",
    "value": "TH"
  },
  {
    "code": "TL",
    "name": "Timor-Leste",
    "value": "TL"
  },
  {
    "code": "TG",
    "name": "Togo",
    "value": "TG"
  },
  {
    "code": "TK",
    "name": "Tokelau",
    "value": "TK"
  },
  {
    "code": "TO",
    "name": "Tonga",
    "value": "TO"
  },
  {
    "code": "TT",
    "name": "Trinidad and Tobago",
    "value": "TT"
  },
  {
    "code": "TN",
    "name": "Tunisia",
    "value": "TN"
  },
  {
    "code": "TR",
    "name": "Turkey",
    "value": "TR"
  },
  {
    "code": "TM",
    "name": "Turkmenistan",
    "value": "TM"
  },
  {
    "code": "TC",
    "name": "Turks and Caicos Islands",
    "value": "TC"
  },
  {
    "code": "TV",
    "name": "Tuvalu",
    "value": "TV"
  },
  {
    "code": "UG",
    "name": "Uganda",
    "value": "UG"
  },
  {
    "code": "UA",
    "name": "Ukraine",
    "value": "UA"
  },
  {
    "code": "AE",
    "name": "United Arab Emirates",
    "value": "AE"
  },
  {
    "code": "GB",
    "name": "United Kingdom",
    "value": "GB"
  },
  {
    "code": "US",
    "name": "United States",
    "value": "US"
  },
  {
    "code": "UM",
    "name": "United States Minor Outlying Islands",
    "value": "UM"
  },
  {
    "code": "UY",
    "name": "Uruguay",
    "value": "UY"
  },
  {
    "code": "UZ",
    "name": "Uzbekistan",
    "value": "UZ"
  },
  {
    "code": "VU",
    "name": "Vanuatu",
    "value": "VU"
  },
  {
    "code": "VE",
    "name": "Venezuela",
    "value": "VE"
  },
  {
    "code": "VN",
    "name": "Vietnam",
    "value": "VN"
  },
  {
    "code": "VG",
    "name": "Virgin Islands, British",
    "value": "VG"
  },
  {
    "code": "VI",
    "name": "Virgin Islands, U.S.",
    "value": "VI"
  },
  {
    "code": "WF",
    "name": "Wallis and Futuna",
    "value": "WF"
  },
  {
    "code": "EH",
    "name": "Western Sahara",
    "value": "EH"
  },
  {
    "code": "YE",
    "name": "Yemen",
    "value": "YE"
  },
  {
    "code": "ZM",
    "name": "Zambia",
    "value": "ZM"
  },
  {
    "code": "ZW",
    "name": "Zimbabwe",
    "value": "ZW"
  }
];

export const countryForCode = (code) =>{
  return code ? COUNTRIES.find((info)=>{return info.code == code.toUpperCase()}) : undefined;
}
